import hotkeys from 'hotkeys-js';
import { Vector2 } from '@babylonjs/core/Maths/math';

import { UiSystem } from '../System/uiSystem';
import { MouseCatcher } from './mouseCatcher';
import { TouchCatcher } from './touchCatcher';
import { GravityGrid } from '../System/gravityGrid';
import { Player } from './player';
import { startSize } from '../Objects/star';
// import { onlineMap } from '../Map/onlineMap';
import { PlanetMap } from '../Map/planetMap';

export class RealPlayer extends Player {

    // map: onlineMap;
    dustField = false;
    realPlayer = true;

    constructor(system: UiSystem, gravityGrid: GravityGrid, planetMap: PlanetMap) {
        super(system, gravityGrid, planetMap, { temperature: 5000, maxPlanet: 5 });
        this.isStarVisible = true;
        this.createStar();
        this.addMouseEvent();
        this.addKeyEvent();
        this.addZoomCatcher();
        this.resetCamera();
        // this.map = map;

        hotkeys('space', (event, param) => {
            if (this.moving) this.realPlayerAccelerate();
        });

        window.addEventListener('click', () => {
            if (this.moving) this.realPlayerAccelerate();
        });

        setInterval(() => {
            if (this.moving) {
                this.gravityGrid.setCenterAndSize(this.position, this.size);
                this.system.setCenterAndSize(this.position, this.size);
                // if (this.map.started) this.map.send({ position: this.position });
            }
            // console.log(this.direction, this.coronaParticles.maxInitialRotation);
        }, 500);

        window.addEventListener("resize", () => {
            this.checkScreenSize();
        });
        this.checkScreenSize();
        this.system.camera.parent = this.transformMesh;
    }

    // Test to use Motion Blur but not really working
    realPlayerAccelerate() {
        let test = this.accelerate();
        if (test) this.system.addMotionBLur();
    }

    addMouseEvent() {
        if (this.system.checkPlatform()) {
            let touchCatcher = new TouchCatcher(window);
            touchCatcher.addListener((pos: Vector2) => {
                this.sendMove(pos);
            });
        } else {
            let mouseCatcher = new MouseCatcher();
            mouseCatcher.addListener((pos: Vector2, step: Vector2) => {
                this.sendMove(pos);
            });
        }
    }

    keyDirection = new Vector2(0, 0);
    keyMove = 10;
    addKeyEvent() {
        window.addEventListener("keydown", (evt) => {
            let key = evt.keyCode;
            if (key == 37) { // Left Arrow
                this.keyDirection.y = -this.keyMove;
            } else if (key == 38) { // Up Arrow
                this.keyDirection.x = -this.keyMove;
            } else if (key == 39) { // Right Arrow
                this.keyDirection.y = this.keyMove;
            } else if (key == 40) { // Down Arrow
                this.keyDirection.x = this.keyMove;
            }
            if (key == 37 || key == 38 || key == 39 || key == 40) this.sendMove(this.keyDirection);
        });

        window.addEventListener("keyup", (evt) => {
            let key = evt.keyCode;
            if (key == 37 || key == 39) { // Left Arrow
                this.keyDirection.y = 0;
            } else if (key == 38 || key == 40) { // Up Arrow
                this.keyDirection.x = 0;
            } 
            if (key == 37 || key == 38 || key == 39 || key == 40) this.sendMove(this.keyDirection);
        });
    }

    sendMove(pos: Vector2) {
        if (!this.moving) return;
        pos.rotateToRef(Math.PI/4, pos);
        this.moveCatcher.catch(pos);
        //     if (!this.map.started) {
        //     this.moveCatcher.catch(pos);
        // } else {
        //     this.map.send({ destination: pos });
        // }
    }

    maxRadius = 70;
    addZoomCatcher() {
        this.system.scene.registerBeforeRender(() => {
            if (!this.isDead) {
                let newRadius = 30 + Math.pow(this.size * 1000, 1/2);
                newRadius = Math.min(newRadius, this.maxRadius);
                // Large size to check stuff
                // let newRadius = 200;
                this.system.lerpCamera(newRadius);
            }
        });
    }

    checkScreenSize() {
        let width = window.innerWidth;
        let height = window.innerHeight;
        this.maxRadius = 120 * height / width;
    }

    resetCamera() {
        this.system.setCameraRadius(10);
        this.system.setAlpha(0);
    }

    restart() {
        this.resetCamera();
        this.setSize(startSize);
        this.setOpacity(1);
        this.setRealVelocity(1);
        this.setMoving(false);
        this.setPosition(Vector2.Zero());
        this.gravityGrid.setCenterAndSize(this.position, this.size);
        this.transformMesh.position.y = 0;
        this.isDead = false;
        
        this.show();
        this.updateCategory(this.category, true);
        this.system.checkActiveMeshes();
    }

    dispose() {
        this.setMoving(false);
    }

    show() {
        if (this.isStarVisible) return;
        this.isStarVisible = true;
        this.setSize(this.size);
        this.setOpacity(1);
    }
}